export enum ProductSalesReportVariant
{
  Simple,
  Expanded,
  Consolidated,
  ExpandedConsolidated
}
